import React from "react";
import PropTypes from "prop-types";
import InputRange from "components/Common/InputRange";

const GreetingSlider = (props) => {
  const {
    getValue,
    sliderType,
    handleSliderInput
  } = props;

  return (
    <div
      className="Greeting__left-column__slider"
      style={getValue("style") === "Emoji" && sliderType === "duration"
        ? { position: "absolute", visibility: "hidden" }
        : {}}
    >
      <label className="Greeting__left-column__label">
        {sliderType === "duration" ? "Duration" : "Delay"}
      </label>
      <InputRange
        id={sliderType}
        min={sliderType === "duration" ? 2 : 0}
        max={30}
        step={2}
        data-value={getValue(sliderType)}
        value={getValue(sliderType)}
        onChange={handleSliderInput}
        className={`Greeting__left-column__slider__range-input--${sliderType}`}
      />
    </div>
  );
};

GreetingSlider.propTypes = {
  sliderType: PropTypes.string.isRequired,
  getValue: PropTypes.func.isRequired,
  handleSliderInput: PropTypes.func.isRequired
};

export default GreetingSlider;
